export default "__VITE_ASSET__cWllhMSH__"